import React from "react";
import { Router } from "@reach/router";
import loadable from "@loadable/component";
import SigningIn from "./signing-in";
import Redirect from "components/redirect";
import routes from "utils/absoluteRoutes";

const CreateAccount = loadable(() => import("./create-account"));
const Cartedo = loadable(() => import("./cartedo"));
const CheckEmail = loadable(() => import("./check-email"));
const Login = loadable(() => import("./login"));
const ForgotPassword = loadable(() => import("./forgot-password"));
const ResetPassword = loadable(() => import("./reset-password"));
const CreatePassword = loadable(() => import("./create-password"));

const AuthRoutes = () => {
  return (
    <Router className="router">
      <Redirect default to={routes.redirects.notFound} />
      <CreateAccount path="create-account/:partnerAppId" />
      <Cartedo path="cartedo" />
      <Login path="login" />
      <CheckEmail path="check-email" />
      <SigningIn path="sign-in/*" />
      <CreatePassword path="create-password" />
      <ForgotPassword path="forgot-password" />
      <ResetPassword path="reset-password" />
    </Router>
  );
};
export default AuthRoutes;
